import { render } from "./MailBanner.vue?vue&type=template&id=077976cd&scoped=true"
import script from "./MailBanner.vue?vue&type=script&lang=js"
export * from "./MailBanner.vue?vue&type=script&lang=js"

import "./MailBanner.vue?vue&type=style&index=0&id=077976cd&scoped=true&lang=css"

import exportComponent from "/Users/otherview/go/src/github.com/otherview/blockstory/web/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077976cd"]])

export default __exports__